import { render, staticRenderFns } from "./SecuritySettingsView.vue?vue&type=template&id=08933f6e&scoped=true"
import script from "./SecuritySettingsView.vue?vue&type=script&lang=js"
export * from "./SecuritySettingsView.vue?vue&type=script&lang=js"
import style0 from "./SecuritySettingsView.vue?vue&type=style&index=0&id=08933f6e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08933f6e",
  null
  
)

export default component.exports